export default "__VITE_ASSET__CQYzzDFe__"